import { Box, Container, Grid, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { CommonHeading, CommonTitle } from '../../../../layout/Common'
import Shoot from '../../../../layout/Shoot';
import axios from 'axios';


const CustomMade = ({onLoaded, AllProduct}) => {
    const theme = useTheme();

    // const [AllProduct, setAllProduct] = useState([]);
    // const fetchFilteredProducts = async (filters) => {
    //     try {
    //         const response = await axios.get(`${process.env.REACT_APP_BACKEND_APP}/api/GetAllProduct?page=${1}&limit=${3}`);
    //         setAllProduct(response.data.data);
    //     } catch (error) {
    //         console.error('Error fetching products:', error);
    //     } finally {
    //         onLoaded();
    //     }
    // };
    // useEffect(() => {
    //     fetchFilteredProducts();
    // }, [])

    return (
        <>
            <Box sx={{
                backgroundImage: 'url(/images/Custom-Made/section-bg-1.jpg)',
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                position: 'relative',
                padding: { xs: '40px 0px 40px 0px', sm: '70px 0px 70px 0px', md: '120px 0px 120px 0px', lg: '200px 0px 200px 0px' },
                zIndex: '1',
                backgroundAttachment: 'fixed',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    zIndex: '-1',
                    backgroundColor: '#000000d4',
                    top: '0'
                }
            }}>
                <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
                    <Grid xs={12} lg={6}>
                        <Box sx={{ width: { md: '856px', xs: 'auto' }, height: { md: "828px", xs: 'auto' } }}>
                            <img src='/images/Custom-Made/hotspot-background.jpg' width='100%' height='100%' />
                        </Box>
                    </Grid>
                    <Grid xs={12} lg={6}>
                        <Box sx={{ padding: { sm: '60px 10px 60px 10px', xs: '30px 50px' } }}>
                            <Box>
                                <Box sx={{ textAlign: { sm: 'start', xs: 'center' }, pb: 3 }}>
                                    <CommonTitle margin={'0 0 10px 0'} text={'supreme quality'} />
                                    <CommonHeading text={'Stylish Men’s Clothing for Every Occasion'} />
                                </Box>
                                <Typography sx={{
                                    color: '#fff',
                                    fontSize: '16px',
                                    fontFamily: theme.palette.typography.fontFamily1,
                                    mb: { xl: '30px', lg: '42px' },
                                    lineHeight: { md: '1.9', xs: '1.6' },
                                    width: { sm: '80%', xs: '100%' },
                                }}>
                                    Premium fabrics crafted for comfort and confidence. Explore timeless designs that elevate your everyday look. Shop the best in modern menswear today.
                                </Typography>
                            </Box>
                            <Box sx={{ mt: 8 }} maxWidth='xl'>
                                <Grid container>
                                    {
                                        AllProduct.map((val) => {
                                            return (
                                                <Grid xs={12} sm={6} md={4}>
                                                    <Shoot primaryImg={val?.ProductImage} title={val?.ClothesType} price={val.ProductPrice} Pricefontsize={'12px'} TitlefontSize={'18px'} buttonwidth={'100%'} DiscountPrice={val.DiscountPrice} ShirtMeter={val?.ShirtMeter}slug={val.unqid}
                                                        PaintMeter={val?.PaintMeter} FabricType={val?.FabricType} TrouserMeter={val?.TrouserMeter} KurtaMeter={val?.KurtaMeter}
                                                    />
                                                    {/* <Shoot primaryImg={`${process.env.REACT_APP_BACKEND_APP}/uploads/` + val?.ProductImage} title={val?.ClothesType} price={val.ProductPrice} Pricefontsize={'12px'} TitlefontSize={'18px'} buttonwidth={'100%'} DiscountPrice={val.DiscountPrice} ShirtMeter={val?.ShirtMeter}slug={val.unqid}
                                                        PaintMeter={val?.PaintMeter}
                                                    /> */}
                                                </Grid>
                                            )
                                        })
                                    }
                                </Grid>
                            </Box>
                        </Box>
                    </Grid>

                </Grid>

            </Box>
        </>
    )
}

export default CustomMade